// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"32eaad06","453":"3325979c"}[chunkId] + ".chunk.js";
};